import React, { useContext, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FolderIcon from "@material-ui/icons/Folder";

import { DocumentAdminstrationDialogProps } from "../../../../../../@types/components/documentAdminstrationProps.types";
import { AuthContext } from "../../../../../../contexts";
import { IAdminDocument } from "../../../../../../@types/documentAdmnstration.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";

const CreateFolderDialog = ({
	open,
	handleClose,
	parent_folder_id,
	root_folder_id,
	documentList,
	setDocumentList
}: DocumentAdminstrationDialogProps) => {
	const { user } = useContext(AuthContext);
	const [folderName, setFolderName] = useState<string>("");

	const handleChangeFolderName = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value } = event.target;
		setFolderName(value);
	};

	const adminCreateFolder = async () => {
		if (user?._id) {
			const payload: IAdminDocument = {
				document_object_id: null,
				group_owner_object_id: user?._id,
				name: folderName,
				parent_folder_id: parent_folder_id,
				root_folder_id: root_folder_id,
				type: "folder"
			};
			const folderInstance = await trackPromise(api.documentSharing.createFolder(payload));
			if (folderInstance) {
				setDocumentList([...documentList, folderInstance]);
				handleClose();
			}
		} else alert("Some thing went wrong ! please log in again");
	};
	return (
		<div>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">
					<div className="dialog-heading">
						<FolderIcon style={{ color: "orange" }} fontSize="large" />
						<h3>Create Folder</h3>
					</div>
				</DialogTitle>
				<DialogContent>
					<DialogContentText>Enter A Folder Name to Create Your Folder</DialogContentText>
					<TextField
						autoFocus
						margin="dense"
						id="name"
						label="Folder Name"
						type="text"
						fullWidth
						// eslint-disable-next-line arrow-parens
						onChange={(e) => handleChangeFolderName(e)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={adminCreateFolder} color="primary" disabled={folderName === ""}>
						Create
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default CreateFolderDialog;
